<template>
  <div v-if="isMobile" class="app-container">
    <router-view />
  </div>
  <div v-else class="desktop-warning">
    <div class="warning-box">
      <img src="@/assets/darklogo.svg" alt="Scanada Logo" class="logo" />
      <p>This app is only available on mobile devices.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    };
  },
  created() {
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);
    this.setVhUnit();
    window.addEventListener("resize", this.setVhUnit);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
    window.removeEventListener("resize", this.setVhUnit);
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    setVhUnit() {
      document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    }
  }
};
</script>

<style>

html,
body {
  margin: 0;
  padding: 0;
  background-color: #AF3C43; /* or your app's main background */
  height: 100%;
  width: 100%;
}

.app-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: calc(var(--vh) * 100);
  overflow: hidden;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

/* Desktop Warning Box */
.desktop-warning {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--darkerwhite);
}

.warning-box {
  background: var(--white);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
}

.logo {
  width: 180px;
  margin-bottom: 15px;
}

.warning-box p {
  font-size: 16px;
  color: var(--bluegrey);
  font-weight: 500;
}
</style>
